export class MipFactory {
  constructor(instance) {
    this.instance = instance;
  }

  getPests(filters) {
    return this.instance.get(`/v1/pests`, {
      params: filters || null,
    });
  }

  insertPest(data) {
    return this.instance.post(`/v1/pests`, data, {
      timeout: 120000,
    });
  }

  updatePest(id, data) {
    return this.instance.put(`/v1/pests/${id}`, data, {
      timeout: 120000,
    });
  }

  deletePest(id) {
    return this.instance.delete(`/v1/pests/${id}`);
  }

  getPoints(filters) {
    return this.instance.get(`/v1/mip`, {
      params: filters || null,
    });
  }

  getTotals(filters) {
    return this.instance.get(`/v1/mip/level-count`, {
      params: filters || null,
    });
  }

  getPointsDetails(filters) {
    return this.instance.get(`/v1/mip/details`, {
      params: filters || null,
    });
  }
}

export default MipFactory;
